/* Pond Haven mobile drawer a11y: ESC to close, focus trap, body scroll-lock.
   Booster's drawer is a pure CSS checkbox toggle; this only adds keyboard +
   scroll behaviour, it does not change the open/close mechanism. */
(function () {
  var cb = document.getElementById('open-mobile-nav');
  var drawer = document.querySelector('.page__header--mobile .mobile__navigation');
  if (!cb || !drawer) return;
  var SEL = 'a[href],button,input,select,textarea,label[for],[tabindex]:not([tabindex="-1"])';

  function open() {
    document.documentElement.style.overflow = 'hidden';
    drawer.setAttribute('aria-hidden', 'false');
    var f = drawer.querySelector(SEL);
    if (f) f.focus();
  }
  function close() {
    document.documentElement.style.overflow = '';
    drawer.setAttribute('aria-hidden', 'true');
    var ham = document.querySelector('.mobile-submenu-label[for="open-mobile-nav"]');
    if (ham) ham.focus();
  }
  cb.addEventListener('change', function () { cb.checked ? open() : close(); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cb.checked) { cb.checked = false; close(); }
    if (e.key === 'Tab' && cb.checked) {
      var items = Array.prototype.slice.call(drawer.querySelectorAll(SEL)).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
